import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see [serialized-closure]:2
* @route '/sitemap.xml'
*/
export const sitemap = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

sitemap.definition = {
    methods: ["get","head"],
    url: '/sitemap.xml',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/sitemap.xml'
*/
sitemap.url = (options?: RouteQueryOptions) => {
    return sitemap.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/sitemap.xml'
*/
sitemap.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/sitemap.xml'
*/
sitemap.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sitemap.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/sitemap.xml'
*/
const sitemapForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/sitemap.xml'
*/
sitemapForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/sitemap.xml'
*/
sitemapForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sitemap.form = sitemapForm

/**
* @see [serialized-closure]:2
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see [serialized-closure]:2
* @route '/get-started'
*/
export const getStarted = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getStarted.url(options),
    method: 'get',
})

getStarted.definition = {
    methods: ["get","head"],
    url: '/get-started',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/get-started'
*/
getStarted.url = (options?: RouteQueryOptions) => {
    return getStarted.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/get-started'
*/
getStarted.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getStarted.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/get-started'
*/
getStarted.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getStarted.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/get-started'
*/
const getStartedForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getStarted.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/get-started'
*/
getStartedForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getStarted.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/get-started'
*/
getStartedForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getStarted.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

getStarted.form = getStartedForm

/**
* @see [serialized-closure]:2
* @route '/services'
*/
export const services = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: services.url(options),
    method: 'get',
})

services.definition = {
    methods: ["get","head"],
    url: '/services',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/services'
*/
services.url = (options?: RouteQueryOptions) => {
    return services.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/services'
*/
services.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: services.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/services'
*/
services.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: services.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/services'
*/
const servicesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: services.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/services'
*/
servicesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: services.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/services'
*/
servicesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: services.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

services.form = servicesForm

/**
* @see [serialized-closure]:2
* @route '/pricing'
*/
export const pricing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

pricing.definition = {
    methods: ["get","head"],
    url: '/pricing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/pricing'
*/
pricing.url = (options?: RouteQueryOptions) => {
    return pricing.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/pricing'
*/
pricing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/pricing'
*/
pricing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pricing.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/pricing'
*/
const pricingForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pricing.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/pricing'
*/
pricingForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pricing.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/pricing'
*/
pricingForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pricing.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pricing.form = pricingForm

/**
* @see [serialized-closure]:2
* @route '/questions'
*/
export const questions = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: questions.url(options),
    method: 'get',
})

questions.definition = {
    methods: ["get","head"],
    url: '/questions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/questions'
*/
questions.url = (options?: RouteQueryOptions) => {
    return questions.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/questions'
*/
questions.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: questions.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/questions'
*/
questions.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: questions.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/questions'
*/
const questionsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: questions.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/questions'
*/
questionsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: questions.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/questions'
*/
questionsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: questions.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

questions.form = questionsForm

/**
* @see [serialized-closure]:2
* @route '/referral-program'
*/
export const referralProgram = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: referralProgram.url(options),
    method: 'get',
})

referralProgram.definition = {
    methods: ["get","head"],
    url: '/referral-program',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/referral-program'
*/
referralProgram.url = (options?: RouteQueryOptions) => {
    return referralProgram.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/referral-program'
*/
referralProgram.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: referralProgram.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/referral-program'
*/
referralProgram.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: referralProgram.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/referral-program'
*/
const referralProgramForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: referralProgram.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/referral-program'
*/
referralProgramForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: referralProgram.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/referral-program'
*/
referralProgramForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: referralProgram.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

referralProgram.form = referralProgramForm

/**
* @see [serialized-closure]:2
* @route '/testimonials'
*/
export const testimonials = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: testimonials.url(options),
    method: 'get',
})

testimonials.definition = {
    methods: ["get","head"],
    url: '/testimonials',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/testimonials'
*/
testimonials.url = (options?: RouteQueryOptions) => {
    return testimonials.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/testimonials'
*/
testimonials.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: testimonials.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/testimonials'
*/
testimonials.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: testimonials.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/testimonials'
*/
const testimonialsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: testimonials.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/testimonials'
*/
testimonialsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: testimonials.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/testimonials'
*/
testimonialsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: testimonials.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

testimonials.form = testimonialsForm

/**
* @see [serialized-closure]:2
* @route '/welcome'
*/
export const welcome = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(options),
    method: 'get',
})

welcome.definition = {
    methods: ["get","head"],
    url: '/welcome',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/welcome'
*/
welcome.url = (options?: RouteQueryOptions) => {
    return welcome.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/welcome'
*/
welcome.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/welcome'
*/
welcome.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: welcome.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/welcome'
*/
const welcomeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/welcome'
*/
welcomeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/welcome'
*/
welcomeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: welcome.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

welcome.form = welcomeForm

/**
* @see [serialized-closure]:2
* @route '/contact-us'
*/
export const contactUs = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contactUs.url(options),
    method: 'get',
})

contactUs.definition = {
    methods: ["get","head"],
    url: '/contact-us',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/contact-us'
*/
contactUs.url = (options?: RouteQueryOptions) => {
    return contactUs.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/contact-us'
*/
contactUs.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contactUs.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/contact-us'
*/
contactUs.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contactUs.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/contact-us'
*/
const contactUsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contactUs.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/contact-us'
*/
contactUsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contactUs.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/contact-us'
*/
contactUsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contactUs.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contactUs.form = contactUsForm

/**
* @see \App\Http\Controllers\CheckZipCodeController::__invoke
* @see app/Http/Controllers/CheckZipCodeController.php:11
* @route '/check-zipcode'
*/
export const checkZipcode = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkZipcode.url(options),
    method: 'post',
})

checkZipcode.definition = {
    methods: ["post"],
    url: '/check-zipcode',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CheckZipCodeController::__invoke
* @see app/Http/Controllers/CheckZipCodeController.php:11
* @route '/check-zipcode'
*/
checkZipcode.url = (options?: RouteQueryOptions) => {
    return checkZipcode.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckZipCodeController::__invoke
* @see app/Http/Controllers/CheckZipCodeController.php:11
* @route '/check-zipcode'
*/
checkZipcode.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkZipcode.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckZipCodeController::__invoke
* @see app/Http/Controllers/CheckZipCodeController.php:11
* @route '/check-zipcode'
*/
const checkZipcodeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkZipcode.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckZipCodeController::__invoke
* @see app/Http/Controllers/CheckZipCodeController.php:11
* @route '/check-zipcode'
*/
checkZipcodeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkZipcode.url(options),
    method: 'post',
})

checkZipcode.form = checkZipcodeForm

/**
* @see \App\Http\Controllers\ServicePricingController::__invoke
* @see app/Http/Controllers/ServicePricingController.php:11
* @route '/service-pricing'
*/
export const servicePricing = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: servicePricing.url(options),
    method: 'post',
})

servicePricing.definition = {
    methods: ["post"],
    url: '/service-pricing',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ServicePricingController::__invoke
* @see app/Http/Controllers/ServicePricingController.php:11
* @route '/service-pricing'
*/
servicePricing.url = (options?: RouteQueryOptions) => {
    return servicePricing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServicePricingController::__invoke
* @see app/Http/Controllers/ServicePricingController.php:11
* @route '/service-pricing'
*/
servicePricing.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: servicePricing.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ServicePricingController::__invoke
* @see app/Http/Controllers/ServicePricingController.php:11
* @route '/service-pricing'
*/
const servicePricingForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: servicePricing.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ServicePricingController::__invoke
* @see app/Http/Controllers/ServicePricingController.php:11
* @route '/service-pricing'
*/
servicePricingForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: servicePricing.url(options),
    method: 'post',
})

servicePricing.form = servicePricingForm

/**
* @see \App\Http\Controllers\AvailableDatesController::__invoke
* @see app/Http/Controllers/AvailableDatesController.php:10
* @route '/available-dates/{zipCode}'
*/
export const availableDates = (args: { zipCode: string | number } | [zipCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableDates.url(args, options),
    method: 'get',
})

availableDates.definition = {
    methods: ["get","head"],
    url: '/available-dates/{zipCode}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AvailableDatesController::__invoke
* @see app/Http/Controllers/AvailableDatesController.php:10
* @route '/available-dates/{zipCode}'
*/
availableDates.url = (args: { zipCode: string | number } | [zipCode: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { zipCode: args }
    }

    if (Array.isArray(args)) {
        args = {
            zipCode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        zipCode: args.zipCode,
    }

    return availableDates.definition.url
            .replace('{zipCode}', parsedArgs.zipCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AvailableDatesController::__invoke
* @see app/Http/Controllers/AvailableDatesController.php:10
* @route '/available-dates/{zipCode}'
*/
availableDates.get = (args: { zipCode: string | number } | [zipCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableDates.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AvailableDatesController::__invoke
* @see app/Http/Controllers/AvailableDatesController.php:10
* @route '/available-dates/{zipCode}'
*/
availableDates.head = (args: { zipCode: string | number } | [zipCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: availableDates.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AvailableDatesController::__invoke
* @see app/Http/Controllers/AvailableDatesController.php:10
* @route '/available-dates/{zipCode}'
*/
const availableDatesForm = (args: { zipCode: string | number } | [zipCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableDates.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AvailableDatesController::__invoke
* @see app/Http/Controllers/AvailableDatesController.php:10
* @route '/available-dates/{zipCode}'
*/
availableDatesForm.get = (args: { zipCode: string | number } | [zipCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableDates.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AvailableDatesController::__invoke
* @see app/Http/Controllers/AvailableDatesController.php:10
* @route '/available-dates/{zipCode}'
*/
availableDatesForm.head = (args: { zipCode: string | number } | [zipCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableDates.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

availableDates.form = availableDatesForm

/**
* @see \App\Http\Controllers\ZipCodeLookupController::__invoke
* @see app/Http/Controllers/ZipCodeLookupController.php:10
* @route '/zip-code-lookup/{zip}'
*/
export const zipCodeLookup = (args: { zip: string | number } | [zip: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: zipCodeLookup.url(args, options),
    method: 'get',
})

zipCodeLookup.definition = {
    methods: ["get","head"],
    url: '/zip-code-lookup/{zip}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZipCodeLookupController::__invoke
* @see app/Http/Controllers/ZipCodeLookupController.php:10
* @route '/zip-code-lookup/{zip}'
*/
zipCodeLookup.url = (args: { zip: string | number } | [zip: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { zip: args }
    }

    if (Array.isArray(args)) {
        args = {
            zip: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        zip: args.zip,
    }

    return zipCodeLookup.definition.url
            .replace('{zip}', parsedArgs.zip.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZipCodeLookupController::__invoke
* @see app/Http/Controllers/ZipCodeLookupController.php:10
* @route '/zip-code-lookup/{zip}'
*/
zipCodeLookup.get = (args: { zip: string | number } | [zip: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: zipCodeLookup.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZipCodeLookupController::__invoke
* @see app/Http/Controllers/ZipCodeLookupController.php:10
* @route '/zip-code-lookup/{zip}'
*/
zipCodeLookup.head = (args: { zip: string | number } | [zip: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: zipCodeLookup.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZipCodeLookupController::__invoke
* @see app/Http/Controllers/ZipCodeLookupController.php:10
* @route '/zip-code-lookup/{zip}'
*/
const zipCodeLookupForm = (args: { zip: string | number } | [zip: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: zipCodeLookup.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZipCodeLookupController::__invoke
* @see app/Http/Controllers/ZipCodeLookupController.php:10
* @route '/zip-code-lookup/{zip}'
*/
zipCodeLookupForm.get = (args: { zip: string | number } | [zip: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: zipCodeLookup.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZipCodeLookupController::__invoke
* @see app/Http/Controllers/ZipCodeLookupController.php:10
* @route '/zip-code-lookup/{zip}'
*/
zipCodeLookupForm.head = (args: { zip: string | number } | [zip: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: zipCodeLookup.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

zipCodeLookup.form = zipCodeLookupForm

/**
* @see [serialized-closure]:2
* @route '/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/dashboard'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/dashboard'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/dashboard'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \App\Http\Controllers\CatchAllController::catchAll
* @see app/Http/Controllers/CatchAllController.php:15
* @route '/{slug}'
*/
export const catchAll = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: catchAll.url(args, options),
    method: 'get',
})

catchAll.definition = {
    methods: ["get","head"],
    url: '/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CatchAllController::catchAll
* @see app/Http/Controllers/CatchAllController.php:15
* @route '/{slug}'
*/
catchAll.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return catchAll.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CatchAllController::catchAll
* @see app/Http/Controllers/CatchAllController.php:15
* @route '/{slug}'
*/
catchAll.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: catchAll.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CatchAllController::catchAll
* @see app/Http/Controllers/CatchAllController.php:15
* @route '/{slug}'
*/
catchAll.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: catchAll.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CatchAllController::catchAll
* @see app/Http/Controllers/CatchAllController.php:15
* @route '/{slug}'
*/
const catchAllForm = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: catchAll.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CatchAllController::catchAll
* @see app/Http/Controllers/CatchAllController.php:15
* @route '/{slug}'
*/
catchAllForm.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: catchAll.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CatchAllController::catchAll
* @see app/Http/Controllers/CatchAllController.php:15
* @route '/{slug}'
*/
catchAllForm.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: catchAll.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

catchAll.form = catchAllForm
